export const FEATURES = [
  {
    name: 'HippoMenu',
    description: `This text will be about the Hippomenu and the exclusive deals
                  that we will offer at DeliveryHippo.This text will be about
                  the Hippomenu and the exclusive deals that we will offer at
                  DeliveryHippo.`,
    image: require('../resources/images/features_browser.png')
  },
  {
    name: 'Reorder Quick and Easy and Fast',
    description: `This text will be about the Hippomenu and the exclusive deals
                  that we will offer at DeliveryHippo.This text will be about
                  the Hippomenu and the exclusive deals that we will offer at
                  DeliveryHippo.`,
    image: require('../resources/images/features_rocket.png')
  },
  {
    name: 'Photos',
    description: `This text will be about the Hippomenu and the exclusive deals
                  that we will offer at DeliveryHippo.This text will be about
                  the Hippomenu and the exclusive deals that we will offer at
                  DeliveryHippo.`,
    image: require('../resources/images/features_camera.png')
  },
  {
    name: 'Future Orders',
    description: `This text will be about the Hippomenu and the exclusive deals
                  that we will offer at DeliveryHippo.This text will be about
                  the Hippomenu and the exclusive deals that we will offer at
                  DeliveryHippo.`,
    image: require('../resources/images/features_clock.png')
  }
];



// WEBPACK FOOTER //
// ./src/constants/features.ts